export const termsAndConditionsUrl =
    'https://knitandnote.com/privacy-and-terms/';
